import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicList from './components/PublicList';

// Public shared lists (/list/<token>) are reachable without logging in
const publicListMatch = window.location.pathname.match(/^\/list\/([\w-]+)\/?$/);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {publicListMatch ? <PublicList token={publicListMatch[1]} /> : <App />}
  </React.StrictMode>
);

